import React from "react";
import Card from "../../shared/Card";

function TransporterDetails(props) {
  return (
    <Card
      cardType="default"
      cardHeader="Transporter Details"
      headerColor="#046B99"
      headerTextColor="white"
      cardBody={
        <div className="" style={{ minHeight: "174px" }}>
          <div className="manifest-transporter-table table-responsive">
            <table className="table" style={{ marginBottom: 0 }}>
              <thead>
                <tr>
                  <th
                    className="col-xs-3 pt-0 pb-1"
                    style={{ borderTop: "none" }}
                  >
                    Order No.
                  </th>
                  <th
                    className="col-xs-8 pt-0 pb-1"
                    style={{ borderTop: "none" }}
                  >
                    Transporter EPAID
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.Manifest.TRANSPORTER_EPA_ID.map((value, index) => {
                  return (
                    <tr key={index}>
                      <td>{value.OrderNum}</td>

                      <td>
                        <a href={`/facility/${value.EpaSiteId}`} target="_blank">
                          {value.EpaSiteId}
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      }
      cardColor="white"
    />
  );
}

export default TransporterDetails;
